import { useSelector } from 'react-redux';

import { payloadSel, querySel } from '@modules/location/duck/selectors';
import {
  useGetCompletePersonProfileQuery,
  useGetPersonProfileQuery,
  useGetPersonTrainingsYPTQuery,
  useGetUserSubscriptionsQuery,
} from '@modules/rtk/esb-api';

import { adultDetailsSel } from './selectors';

export function useAdultProfile() {
  const { personGuid, userId }: { personGuid?: string; userId?: number } =
    useSelector(adultDetailsSel);
  const { adultUserId = '' }: { adultUserId: string } =
    useSelector(querySel) || {};
  const { userId: parentId }: { userId?: string } =
    useSelector(payloadSel) || {};
  let sbPersonGuid: string | undefined = personGuid;

  const sbProfileData = useGetPersonProfileQuery(
    { userId: !userId ? Number(parentId) : userId },
    { skip: !parentId && !userId },
  );
  if (sbProfileData.data?.profile?.personGuid) {
    sbPersonGuid = sbProfileData.data.profile.personGuid;
  }

  const finalPersonGuid = personGuid || sbPersonGuid || '';
  // if adultUserId has a value it means is an unregistered (in akela) adult (usually a parent profile being redirected from Scout book)
  const skip = !finalPersonGuid || !!adultUserId;
  const akelaProfileData = useGetCompletePersonProfileQuery(
    { personGuid: finalPersonGuid },
    { skip },
  );

  const yptTrainingData = useGetPersonTrainingsYPTQuery(
    { personGuid: finalPersonGuid },
    { skip },
  );

  const subscriptionsData = useGetUserSubscriptionsQuery(
    { personGuid: finalPersonGuid },
    { skip },
  );

  return {
    personGuid: finalPersonGuid,
    userId: Number(userId ? userId : parentId),
    sbProfileData,
    akelaProfileData,
    yptTrainingData,
    subscriptionsData,
  };
}
